/* global  */
import ApiClient from './ApiClient';

class ReportCostsAPI extends ApiClient {
  constructor() {
    // TODO: Update endpoint when backend is ready
    super('report_costs', { accountScoped: true });
  }

  getCostList(params = {}) {
    // TODO: Replace with actual API call when backend is ready
    // return axios.get(`${this.url}`, { params });

    // Dummy data for now
    return new Promise(resolve => {
      setTimeout(() => {
        const dummyData = {
          data: this.constructor.getDummyData(),
          meta: {
            count: 10,
            current_page: params.page || 1,
            page_size: params.page_size || 15,
          },
        };
        resolve({ data: dummyData });
      }, 500);
    });
  }

  static getDummyData() {
    return [
      {
        id: 1,
        name: 'GPT-4 Chatbot',
        model: 'gpt-4',
        type: 'LLM',
        cost_per_call: 0.03,
        currency: 'USD',
        total_calls: 15234,
        total_cost: 457.02,
        status: 'active',
        last_used_at: '2026-01-07T14:30:00Z',
      },
      {
        id: 2,
        name: 'Claude Assistant',
        model: 'claude-3-opus',
        type: 'LLM',
        cost_per_call: 0.015,
        currency: 'USD',
        total_calls: 8742,
        total_cost: 131.13,
        status: 'active',
        last_used_at: '2026-01-07T12:15:00Z',
      },
      {
        id: 3,
        name: 'Image Generator',
        model: 'dall-e-3',
        type: 'Vision',
        cost_per_call: 0.04,
        currency: 'USD',
        total_calls: 523,
        total_cost: 20.92,
        status: 'active',
        last_used_at: '2026-01-06T18:45:00Z',
      },
      {
        id: 4,
        name: 'Whisper Transcriber',
        model: 'whisper-v2',
        type: 'Audio',
        cost_per_call: 0.006,
        currency: 'USD',
        total_calls: 12450,
        total_cost: 74.7,
        status: 'active',
        last_used_at: '2026-01-07T09:20:00Z',
      },
      {
        id: 5,
        name: 'Embeddings Service',
        model: 'text-embedding-3-small',
        type: 'Embedding',
        cost_per_call: 0.0001,
        currency: 'USD',
        total_calls: 45678,
        total_cost: 4.57,
        status: 'active',
        last_used_at: '2026-01-07T16:00:00Z',
      },
      {
        id: 6,
        name: 'Legacy GPT-3.5 Bot',
        model: 'gpt-3.5-turbo',
        type: 'LLM',
        cost_per_call: 0.002,
        currency: 'USD',
        total_calls: 34500,
        total_cost: 69.0,
        status: 'inactive',
        last_used_at: '2025-12-15T10:30:00Z',
      },
      {
        id: 7,
        name: 'Code Assistant',
        model: 'gpt-4-code',
        type: 'LLM',
        cost_per_call: 0.035,
        currency: 'USD',
        total_calls: 4521,
        total_cost: 158.24,
        status: 'active',
        last_used_at: '2026-01-07T11:45:00Z',
      },
      {
        id: 8,
        name: 'Translation Bot',
        model: 'claude-3-haiku',
        type: 'LLM',
        cost_per_call: 0.0025,
        currency: 'USD',
        total_calls: 6789,
        total_cost: 16.97,
        status: 'active',
        last_used_at: '2026-01-07T15:30:00Z',
      },
      {
        id: 9,
        name: 'Summarizer',
        model: 'gpt-4-turbo',
        type: 'LLM',
        cost_per_call: 0.01,
        currency: 'USD',
        total_calls: 12345,
        total_cost: 123.45,
        status: 'active',
        last_used_at: '2026-01-07T08:15:00Z',
      },
      {
        id: 10,
        name: 'Sentiment Analyzer',
        model: 'text-davinci-003',
        type: 'Analytics',
        cost_per_call: 0.02,
        currency: 'USD',
        total_calls: 2345,
        total_cost: 46.9,
        status: 'inactive',
        last_used_at: '2025-11-20T14:00:00Z',
      },
    ];
  }
}

export default new ReportCostsAPI();
